import React, { Fragment } from 'react';

import { connect } from 'react-redux';

import { Logs } from 'modules/log';
import History from 'modules/Common/History';

import { PENDING_MODERATION } from 'modules/shipper-order/Form/constants';

import { addManualEntryLog } from 'redux/modules/shipper-order-detail/effects';

import { getShipperOrderDetailData } from 'redux/modules/shipper-order-detail/selectors';

import { SidebarTabStyled } from 'modules/detail/styled';

import { Flexer } from '@ontruck/orc';

const t = {
  ALERTS: 'ALERTS',
  LOG: 'LOG',
};

const SidebarQueued = ({ fetching, shipperOrderId, shipperOrder, addManualEntryLog }) => {
  return (
    <Fragment>
      <Flexer.Parent>
        <SidebarTabStyled active>{t.LOG}</SidebarTabStyled>
      </Flexer.Parent>
      <Logs
        shipperOrderId={shipperOrderId}
        onCreateLogClick={addManualEntryLog}
        showAddLog={(shipperOrder || {}).status === PENDING_MODERATION}
        flex="2"
      />
      <History flex="1" journey={shipperOrder} />
    </Fragment>
  );
};

const actionCreators = {
  addManualEntryLog,
};

export default connect(
  (state) => ({
    shipperOrder: getShipperOrderDetailData(state),
  }),
  actionCreators
)(SidebarQueued);
